import { Card, LegacyCard, Page } from '@shopify/polaris';
import { useContext, useMemo, useState } from 'react';
import { useParams } from 'react-router';
import { SET_OK, SET_ERROR } from '../../../context/ToastReducer';
import ToastContext from '../../../context/ToastContext';
import { getSearchParams, handleSearchParams } from '../../../helpers/handleSearchParams';
import { NewInventoryModal } from '../../UI/Inventories/NewInventoryModal';
import { checkPermission } from '../../../services/permissionsService';
import FiltersInventories from '../../UI/Inventories/FiltersInventories';
import { getInventories, postInventory } from '../../../services/inventoriesService';
import ListInventories from '../../UI/Inventories/ListInventories';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';

const ViewInventories = () => {
  const { id } = useParams();
  const [, dispatchToast] = useContext(ToastContext);
  const navigate = useHistory();

  const [currentFilters, setCurrentFilters] = useState(() => {
    const params = {
      deposits: getSearchParams('deposits') || undefined,
      states: getSearchParams('states') || undefined,
      s: getSearchParams('s') || '',
      page: getSearchParams('page') || 1,
    };

    return Object.keys(params).reduce((acc, k) => {
      if (params[k]) acc[k] = params[k];
      return acc;
    }, {});
  });

  const { data, isLoading, error, refetch } = useQuery(['inventories', currentFilters], () =>
    getInventories({
      ...currentFilters,
      limit: 30,
    }).then((r) => r.data),
  );

  const [inventories, metadata, totalCount] = useMemo(() => {
    if (!data) return [[], {}, 0];
    return [data.data, data.metadata, data.metadata.count || 0];
  }, [data]);

  const handleFilter = ({ slug, value }) => {
    handleSearchParams(slug, value);
    setCurrentFilters((prev) => {
      const params = { ...prev, [slug]: value || null };
      return Object.keys(params).reduce((acc, k) => {
        if (params[k]) acc[k] = params[k];
        return acc;
      }, {});
    });
  };

  const createNewInventory = (form) => {
    const depositId = form.depositId;
    delete form.startDateManually;
    delete form.depositId;
    if (form.startDate === '' || form.startDate === null) delete form.startDate;

    return postInventory(depositId, form)
      .then((r) => {
        dispatchToast({ type: SET_OK, payload: r.data });
        refetch();
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
      });
  };

  const fetchNextPage = () => {
    handleFilter({ slug: 'page', value: Number(metadata.page) + 1 });
  };
  const hasNextPage = metadata.page * metadata.limit < metadata.count ?? false;

  const fetchPreviousPage = () => {
    handleFilter({ slug: 'page', value: Number(metadata.page) - 1 });
  };
  const hasPreviousPage = metadata.page > 1 ?? false;

  return (
    <Page
      backAction={{ content: 'Volver', onAction: () => navigate.goBack() }}
      title="Inventarios"
      subtitle={isLoading ? 'Cargando...' : `${totalCount} inventarios`}
      primaryAction={
        checkPermission('INVENTORY:CREATE') && (
          <NewInventoryModal
            onAddInventory={createNewInventory}
            suggestId={
              [...new Set(inventories.map((i) => i.deposit.id))].length === 1 ? inventories[0].deposit.id : null
            }
          />
        )
      }
      // divider
    >
      <Card roundedAbove="sm">
        <FiltersInventories onFilterChange={handleFilter} initialFilters={currentFilters} />
      </Card>
      <div style={{ height: '10px' }}></div>
      <LegacyCard>
        <ListInventories
          data={inventories}
          isLoading={isLoading}
          error={error}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          fetchPreviousPage={fetchPreviousPage}
          hasPreviousPage={hasPreviousPage}
          onAddInventory={createNewInventory}
          depositId={id}
        />
      </LegacyCard>
    </Page>
  );
};

export default ViewInventories;
